import validate from "/builds/web/REPLAYS_PORTAL/mk_replays/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45trailing_45slash_45global from "/builds/web/REPLAYS_PORTAL/mk_replays/frontend/middleware/redirectTrailingSlash.global.ts";
import manifest_45route_45rule from "/builds/web/REPLAYS_PORTAL/mk_replays/frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirect_45trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/builds/web/REPLAYS_PORTAL/mk_replays/frontend/middleware/auth.ts")
}